<template>
  <a-select
    :value="value"
    :placeholder="effectivePlaceholder"
    :disabled="disabled"
    :style="selectStyle"
    :allow-clear="allowClear"
    dir="rtl"
    @change="$emit('change', $event)"
  >
    <a-select-option
      v-for="opt in options"
      :key="opt.value"
      :value="opt.value"
    >
      {{ opt.label }}
    </a-select-option>
  </a-select>
</template>

<script>
import {
  PV_DECISION_KEY_OPTIONS,
} from "@/constants/boardDecisionPresets";

export default {
  name: "PvDecisionKeySelect",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allowClear: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    selectStyle: {
      type: [Object, String],
      default: () => ({ width: "100%" }),
    },
  },
  data() {
    return {
      options: PV_DECISION_KEY_OPTIONS,
    };
  },
  computed: {
    effectivePlaceholder() {
      return this.placeholder || this.$t("certification.Corresponding");
    },
  },
};
</script>
